import React from 'react'

export const Overview = ({data}) => {
    const bulletBg = "bg-primary"
    console.log(data)
  return (
    <div className='flex flex-col gap-6'>
        <div className='flex gap-2 flex-col'>
            <h2 className='md:text-lg text-[#00000] font-ManropeBold leading-[20px] '>Course Description</h2>
            <p className='text-[#102844] text-[14px] leading-[20px] font-inter'>{data?.course.description}</p>
        </div>
        <div className=''>
                <h2 className='md:text-lg text-[#00000] font-ManropeBold leading-[20px] '>Course Outcome</h2>
                <div className='grid md:grid-cols-2 grid-cols-1 gap-8'>
                {
                    data?.courseOutcome?.map((outcome)=>(
                        <div className='flex  gap-2'>
                            <span className={`${bulletBg} w-2 h-2 rounded-full`}></span>
                            <p>{outcome?.outcome}</p>
                        </div>
                    ))
                }
                </div>
        </div>
        <div className='flex gap-2 flex-col'>
            <h2 className='md:text-lg text-[#00000] font-ManropeBold leading-[20px] '>Audience</h2>
            <p className='text-[#102844] text-[14px] leading-[20px] font-ManropeLight'>{data?.audience}</p>
        </div>
    </div>
  )
}
